var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17161",
    "data-name": "Group 17161",
    transform: "translate(-377 -279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(377 279)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "question_1_",
    "data-name": "question (1)",
    transform: "translate(379 281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17159",
    "data-name": "Group 17159",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8341",
    "data-name": "Path 8341",
    d: "M7.922,0A7.951,7.951,0,0,0,0,7.92a7.858,7.858,0,0,0,1.109,4.022L.026,15.229a.464.464,0,0,0,.587.587L3.9,14.73A7.858,7.858,0,0,0,7.922,15.84,7.92,7.92,0,1,0,7.922,0Zm0,13.953A1.392,1.392,0,1,1,9.314,12.56,1.394,1.394,0,0,1,7.922,13.953ZM9.878,7.276,8.85,8.3V9.312a.928.928,0,0,1-1.856,0V8.3a1.844,1.844,0,0,1,.544-1.312L8.566,5.964a.987.987,0,0,0,.284-.785.972.972,0,0,0-.971-.971.887.887,0,0,0-.886.886.928.928,0,0,1-1.856,0A2.745,2.745,0,0,1,7.879,2.351a2.83,2.83,0,0,1,2.827,2.827A2.82,2.82,0,0,1,9.878,7.276Z",
    transform: "translate(-0.002)",
    fill: "#3f2566"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.ebfc0b5f81004d731bf180c79724cbcd.svg";
export { ForwardRef as ReactComponent };